import {CheckUnregisterVo} from '../../common/shared/api/nicolas/vo/CheckUnregisterVo.interface';
import {CheckUnregister} from '../generated/types';

export function createCheckUnregister(
  checkUnregister: CheckUnregisterVo
): CheckUnregister {
  return {
    hasPaidTickets: checkUnregister.has_paid_tickets,
    hasPaidCash: checkUnregister.has_paid_cash,
    paidCashAmount: checkUnregister.paid_cash_amount,
  };
}
